webpackJsonp([114842950261596],{

/***/ 491:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"excerpt":"Motivation For a long time I was using Visual Studio with TFS to control my code. So when company I was working at that time wanted to move to git I continued to use integreated tools as well. And in a small team it was fine, basicly I couldn't tell…","frontmatter":{"title":"Using git on Windows","date":"2017-09-05T00:00:00.000Z","path":"/using-git-on-windows"}}}]}},"pathContext":{"siteTitle":"Martin Vích's blog","tagName":"Windows","name":"Windows"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-windows-afefe1ca538362f3b608.js